module.exports = __webpack_public_path__ + "static/media/blog6.a983c1bb.jpg";